import { useContext } from 'react';

import type { InformationOverlayContextType } from '../contexts/InformationOverlayContext.js';
import { InformationOverlayContext } from '../contexts/InformationOverlayContext.js';

/**
 * @internal
 */
export const useInformationOverlayContext = (): InformationOverlayContextType =>
  useContext(InformationOverlayContext);
